const STORAGE_BASE_URL = 'https://archicloudstore.blob.core.windows.net/archiconnect-container';

export function normalizeStorageImagePath(selectedFile: string | null | undefined): string | null {
  const normalizedPath = selectedFile?.trim();

  if (!normalizedPath || normalizedPath === 'null' || normalizedPath === 'undefined') {
    return null;
  }

  return normalizedPath;
}

export function getStorageImageUrl(selectedFile: string | null | undefined): string | null {
  const normalizedPath = normalizeStorageImagePath(selectedFile);
  return normalizedPath ? `${STORAGE_BASE_URL}/${normalizedPath}` : null;
}
